module.exports = __webpack_public_path__ + "public/SiteIcons/mailLight.png?de2d3422";